//@ts-nocheck - window.gtag events are not typed
const gtagEvents = {
    beginCheckout: () => window.gtagBeginCheckout?.(),
    signup: () => window.gtagSignup?.(),
    subscribe: () => window.gtagSubscribe?.(),
    addToCart: () => window.gtagAddToCart?.(),
};

export default gtagEvents;
